import { render } from "./couponmanagement.vue?vue&type=template&id=064e2dab&scoped=true"
import script from "./couponmanagement.vue?vue&type=script&lang=js"
export * from "./couponmanagement.vue?vue&type=script&lang=js"

import "./couponmanagement.vue?vue&type=style&index=0&id=064e2dab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064e2dab"]])

export default __exports__